export default {
  lstTab: {
    economy: 'Economy',
    watchlist: 'Watchlist',
    corporate: 'Corporate',
  },
};
